export class RemoteData {
  public isSuccess: boolean | undefined;
  public code: string | undefined;
  public error: string | undefined;
  public message: string | undefined;
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/ng-api/remote-data.model.ts